<template>
    <div>
        <vs-row class="pt-3 pb-3">
            <vs-col v-for="(info, index) in infoCobros" v-bind:key="index" class="widthCard">
                <md-card class="text-center" :class="info.color" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">{{info.total | currency}}</div>
                        <div class="md-subhead">{{info.title}}</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import cobranza from '../../../api/requests/cobranza-persona.js'
export default {
    props:[
        'personaId',
        'cicloEscolar',
        'institucion',
    ],
    data () {
        return {
            estadisticaPago:{},
            infoCobros: []
        }
    },
    methods: {
        getPagos(datos) {
            const info = {
                "inscripcion": datos.inscripcion ? datos.inscripcion : 0,
                "colegiatura": datos.colegiatura ? datos.colegiatura : 0,
                "servicios": datos.servicios ? datos.servicios : 0,
                "descuentos": datos.descuentos ? datos.descuentos : 0
            }
            const result = []
            if (info.inscripcion) {
                const obj = {
                    "title": 'Pago de inscripción',
                    "total": info.inscripcion,
                    "color": 'md-succes'
                }
                result.push(obj)
            }
            if (info.colegiatura) {
                const obj = {
                    "title": 'Pago de colegiaturas',
                    "total": info.colegiatura,
                    "color": 'md-primary'
                }
                result.push(obj)
            }
            if (info.servicios) {
                const obj = {
                    "title": 'Pago de servicios',
                    "total": info.servicios,
                    "color": 'md-info'
                }
                result.push(obj)
            }
            if (info.descuentos) {
                const obj = {
                    "title": 'Descuentos por promociones',
                    "total": info.descuentos,
                    "color": 'md-dark'
                }
                result.push(obj)
            }
            return result
        },
        async getEstadisticasPagos(){
            try {
                let params = {
                    id : this.personaId,
                    ciclo_escolar: this.cicloEscolar,
                    institucion: this.institucion
                }
                const response = await cobranza.getInfoEstadisticasPago(params)
                this.infoCobros = this.getPagos(response.data)
                // if (response.data instanceof Object){
                //     this.dataEstadisticosGral = response.data  
                // }

            } catch (error) {
                
            }
        },
    },
}
</script>
<style lang="scss"  scoped >
.md-succes{
    background: #28a745;
    color: white;
    border-radius: 7px;
}

.widthCard{
    width: 22%;
    margin: 0 1.5%;
    @media only screen and (max-width: 768px) {
        width: 47%;
        margin: 1.5%;
    }
}

.md-info{
    background: #9e16aa;
    color: white;
    border-radius: 7px;
}

.md-dark{
    background: #19191a;
    color: white;
    border-radius: 7px;
}
</style>